module.exports = __webpack_public_path__ + "static/media/TLogo.48118814.svg";